import {Component, Injectable} from '@angular/core';
import {Filter} from '../../../models/warranties/filter.model';
import {SpecialRequestService} from 'src/app/special-request/special-request.service';
import {SpecialRequest} from '../../../special-request/special-request.model';
import {MessagesUtil} from '../messages-util';

@Component({
  selector: 'app-messages-menu',
  templateUrl: './message-menu.component.html',
  styleUrls: ['./message-menu.component.css']
})

@Injectable({
  providedIn: 'root'
})
export class MessageMenuComponent {

  filter: Filter = new Filter();
  unreadMessages: number;

  constructor(public specialRequestService: SpecialRequestService) {
  }

  displayMessages() {
    this.specialRequestService.fetchSpecialRequests(this.filter).subscribe((specialRequests) => {
      this.displayMessagesFromSpecialRequests(MessagesUtil.selectSpecialRequestsNotBeingReviewed(specialRequests));
    });
    this.displayMessageCounter();
  }

  displayMessagesFromSpecialRequests(specialRequests: Array<SpecialRequest>) {
    this.specialRequestService.specialRequests = specialRequests;
    this.displayMessageCounter();
  }

  displayMessageCounter(): boolean {
    this.unreadMessages = this.specialRequestService?.specialRequests?.filter((val) => val.messageRead === false)?.length;
    return this.unreadMessages > 0;
  }
}
